import React from "react";
import { Typography, Button, Paper } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: "center",
  },
  heading: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

const AccessDeniedPage = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    history.push("/details");
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="h4" className={classes.heading}>
          Access Denied
        </Typography>
        <Typography variant="body1">
          You don't have permission to access this page.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleClick}
        >
          Go to Details
        </Button>
      </Paper>
    </div>
  );
};

export default AccessDeniedPage;
